import React, { useState, useEffect } from 'react';
import "./css/ImageCarousel.css";
import { Icon } from '@iconify/react';

const ImageCarousel = ({ pocList = [], pocImages = [] }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        setCurrentIndex(0);
    }, [pocList, pocImages]);

    // Safely combine PoC descriptions and blob URLs
    const combinedList = Array.isArray(pocImages)
        ? pocImages.map((image, index) => {
            // Fallback to previous valid description if current one is missing
            let description = "";
            if (pocList && Array.isArray(pocList)) {
                for (let i = index; i >= 0; i--) {
                    if (pocList[i] && pocList[i].poc) {
                        description = pocList[i].poc;
                        break;
                    }
                }
            }
            return {
                poc: description || "No description provided",
                url: image.objectUrl || "",
            };
        })
        : [];


    const safeIndex = Math.min(currentIndex, combinedList.length - 1);

    const prevSlide = () => {
        setCurrentIndex(prev => (prev === 0 ? combinedList.length - 1 : prev - 1));
    };

    const nextSlide = () => {
        setCurrentIndex(prev => (prev === combinedList.length - 1 ? 0 : prev + 1));
    };

    const selectImage = (index) => {
        setCurrentIndex(index);
    };

    if (!Array.isArray(combinedList) || combinedList.length === 0) {
        return <div>No PoC images available.</div>;
    }

return (
  <div className="carousel-wrapper">
    {/* ✅ PoC description at the top */}
    <div className="poc-description">
      <p className="poc-text">
        {combinedList[safeIndex].poc}
      </p>
    </div>

    {/* ✅ Navigation + Main Image + Arrows */}
    <div className="main-image-navigation">
      <button className="arrow left" onClick={prevSlide}>
        <Icon icon="weui:arrow-outlined" width="20" height="40" style={{ transform: 'rotate(180deg)' }} />
      </button>

      <div className="main-image-box">
        <img
          src={combinedList[safeIndex].url}
          alt={`PoC ${safeIndex}`}
          className="main-image"
          onError={(e) => {
            console.error("Image failed to load:", e.target.src);
          }}
        />
      </div>

      <button className="arrow right" onClick={nextSlide}>
        <Icon icon="weui:arrow-outlined" width="20" height="40" />
      </button>
    </div>

    {/* ✅ Thumbnails below main image */}
    <div className="thumbnail-container">
      {combinedList.map((entry, index) => (
        <img
          key={index}
          src={entry.url}
          alt={`PoC ${index}`}
          className={`thumbnail ${index === safeIndex ? "active" : ""}`}
          onClick={() => selectImage(index)}
          onError={(e) => {
            console.error("Thumbnail failed to load:", e.target.src);
          }}
        />
      ))}
    </div>
  </div>
);

};

export default ImageCarousel;
